import { TermsBody } from "../public/terms";

// In-app Terms of Service (Platform Owner → Settings → Terms of Service).
const TermsPage = () => (
  <div className="dashboard">
    <section className="panel">
      <div className="panel__head">
        <div>
          <h2>Terms of Service</h2>
        </div>
      </div>
      <div className="panel__body">
        <TermsBody />
      </div>
    </section>
  </div>
);

export default TermsPage;
